import React from "react";
import { MyContext } from "../context";
import { Header, Loader } from "../components";
import { Helmet } from "react-helmet";
import WSManager from "../helper/WSManager";
import * as NC from "../helper/NetworkingConstants";
import _ from "lodash";
import MetaData from "../helper/MetaData";

const getTextScoreResult = (fixtureQueResult, ContestData) => {
  const questionName = (fixtureQueResult.question_name || "").toLowerCase();
  const isAwayScore = questionName.indexOf("away") > -1;
  const teamName = isAwayScore
    ? ContestData.match_data.away
    : ContestData.match_data.home;

  return {
    teamName: teamName,
    teamFlag: isAwayScore
      ? ContestData.match_data.away_flag
      : ContestData.match_data.home_flag,
    userScore: isAwayScore
      ? fixtureQueResult.user_away_score
      : fixtureQueResult.user_home_score,
    correctScore: isAwayScore
      ? fixtureQueResult.away_score
      : fixtureQueResult.home_score
  };
};

const isHomeScoreQuestion = item => {
  return (
    item &&
    item.question_type === "text" &&
    (item.question_name || "").toLowerCase() === "home score"
  );
};

const isAwayScoreQuestion = item => {
  return (
    item &&
    item.question_type === "text" &&
    (item.question_name || "").toLowerCase() === "away score"
  );
};

const getDisplayFixtureQueResult = fixtureQueResult => {
  let list = [];

  _.map(fixtureQueResult, (item, idx) => {
    if (isAwayScoreQuestion(item)) {
      return;
    }

    if (isHomeScoreQuestion(item)) {
      const awayIdx = _.findIndex(fixtureQueResult, (question, questionIdx) => {
        return questionIdx > idx && isAwayScoreQuestion(question);
      });
      const awayItem = awayIdx > -1 ? fixtureQueResult[awayIdx] : {};

      list.push({
        ...item,
        _textScoreQuestions: awayIdx > -1 ? [item, awayItem] : [item]
      });
      return;
    }

    list.push(item);
  });

  return list;
};

const FixtureResultList = ({ fixtureQueResult, myContext, idx, ContestData }) => {
  const isTextQuestion = fixtureQueResult.question_type == "text";
  const textScoreQuestions = fixtureQueResult._textScoreQuestions || [
    fixtureQueResult
  ];
  const textScoreResults = isTextQuestion
    ? _.map(textScoreQuestions, item => ({
        ...getTextScoreResult(item, ContestData),
        questionName: item.question_name,
        isCorrect: item.is_correct,
        correctPercentage: item.correct_percentage
      }))
    : [];
  const isResultPending = isTextQuestion
    ? _.some(textScoreResults, item => item.correctScore == null)
    : fixtureQueResult.correct_answer == null;
  const isTextAnswerCorrect = isTextQuestion
    ? _.every(textScoreQuestions, item => {
        return item.is_correct == 1;
      })
    : fixtureQueResult.is_correct == 1;

  return (
    <div
      className={
        (isTextQuestion ? "fixture-result-text-score " : "") +
        (isTextAnswerCorrect ? "choosen-correct" : "")
      }
    >
      {isTextQuestion && (
        <ul
          className={
            "quiz-section text-score-card" +
            (isResultPending ? " quiz-section-rounded" : "")
          }
        >
          <li className="text-score-heading">
            <div className="numbers-text">{idx + 1}</div>
            <div className="quiz-query">
              {textScoreResults.length > 1
                ? "Final Score"
                : textScoreResults[0].questionName}
            </div>
          </li>
          {_.map(textScoreResults, (item, scoreIdx) => (
            <li className="text-score-team-block" key={"scoreTeam" + scoreIdx}>
              <div className="text-score-team-main">
                <div className="score-team-row">
                  <img src={item.teamFlag} alt="" />
                  <div className="score-team-info">
                    <div className="team-selected">{item.teamName}</div>
                    <div className="team-score-value">{item.userScore}</div>
                  </div>
                </div>
                <div className="prediction-result">
                  {isResultPending ? (
                    <React.Fragment>
                      <span>Pending</span>
                      <i className="icon-circular-menu pending" />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {item.isCorrect == 1 ? "Correct" : "Wrong"}
                      <i
                        className={
                          item.isCorrect == 1
                            ? "icon-tick-circular"
                            : "icon-cross-circular"
                        }
                      />
                    </React.Fragment>
                  )}
                </div>
              </div>
              {!isResultPending && (
                <div className="text-score-answer-detail">
                  <div className="text-left">
                    <span className="ans-picked-by">
                      {item.correctPercentage}%
                      <span> of Refs picked {item.correctScore}</span>
                    </span>
                  </div>
                  {item.isCorrect != 1 && (
                    <div className="text-score-correct-answer">
                      <p className="ans-label">Correct Answer</p>
                      <div className="correct-ans">{item.correctScore}</div>
                    </div>
                  )}
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
      {!isTextQuestion && (
        <ul
          className={
            "quiz-section" + (isResultPending ? " quiz-section-rounded" : "")
          }
        >
          <li>
            <div className="numbers-text">{idx + 1}</div>
          </li>
          <React.Fragment>
            <li>
              {fixtureQueResult.selected_option_name ==
                ContestData.match_data.home ? (
                  <img src={ContestData.match_data.home_flag} alt="" />
                ) : fixtureQueResult.selected_option_name ==
                  ContestData.match_data.away ? (
                    <img src={ContestData.match_data.away_flag} alt="" />
                  ) : (
                    <i className="icon-stop blocked" />
                  )}
              <div className="quiz-query">{fixtureQueResult.question_name}</div>
              <div className="team-selected">
                {fixtureQueResult.selected_option_name}
              </div>
            </li>
            {fixtureQueResult.correct_answer == null && (
              <li>
                <div className="prediction-result">
                  <span>Pending</span>
                  <i className="icon-circular-menu pending" />
                </div>
              </li>
            )}
            {fixtureQueResult.correct_answer != null && (
              <li>
                <div className="prediction-result">
                  {fixtureQueResult.is_correct == 1 ? "Correct" : "Wrong"}
                  <i
                    className={fixtureQueResult.is_correct == 1 ? "icon-tick-circular" : "icon-cross-circular"
                    }
                  />
                </div>
              </li>
            )}
          </React.Fragment>
        </ul>
      )}
      {!isTextQuestion && (
        <ul className="ans-picked-detail">
          <React.Fragment>
            <li className="text-left">
              <span className="ans-picked-by">
                {fixtureQueResult.correct_percentage}%
                <span> of ReFPredictors picked </span>
                {fixtureQueResult.correct_option_name}
              </span>
            </li>
            {fixtureQueResult.is_correct != 1 &&
              fixtureQueResult.correct_answer != null && (
                <li>
                  <React.Fragment>
                    <p className="ans-label">Correct Answer</p>
                    <div className="correct-ans">
                      {fixtureQueResult.correct_option_name}
                    </div>
                  </React.Fragment>
                </li>
              )}
          </React.Fragment>
        </ul>
      )}
    </div>
  );
};
export default class AnswerScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ContestData: !_.isUndefined(props.location.state)
        ? props.location.state.ContestData
        : "",
      isFrom: !_.isUndefined(props.location.state)
        ? props.location.state.isFrom
        : "",
      isLoading: false,
      fixtureResult: "",
      fixtureQueResult: []
    };
  }

  componentWillMount() {
    let { ContestData } = this.state;
    let param = {
      fixture_id: ContestData.fixture_id,
      sports_id: NC.sportsId
    };
    this.setState({
      isLoading: true
    });

    WSManager.Rest(NC.baseURL + NC.GET_FIXTURE_RESULT, param).then(
      responseJson => {
        this.setState({
          isLoading: false
        });
        if (responseJson.response_code === NC.successCode) {
          this.setState({
            fixtureResult: responseJson.data,
            fixtureQueResult: responseJson.data.questions
          });
        }
      }
    );
  }

  render() {
    const {
      fixtureResult,
      fixtureQueResult,
      ContestData,
      isLoading
    } = this.state;
    const DisplayFixtureQueResult = getDisplayFixtureQueResult(fixtureQueResult);
    const HeaderOption = {
      back: true,
      Notification: true,
      Logo: true
    };
    return (
      <MyContext.Consumer>
        {context => (
          <div className="web-container">
            <Helmet titleTemplate={`${MetaData.template} | %s`}>
              <title>{MetaData.Prediction.title}</title>
              <meta
                name="description"
                content={MetaData.Prediction.description}
              />
              <meta name="keywords" content={MetaData.Prediction.keywords} />
            </Helmet>
            <Header
              {...this.props}
              HeaderOption={HeaderOption}
              showFilter={this.showFilter}
            />
            {isLoading && <Loader />}
            <div className="heading-section-sm">
              {ContestData.match_data.home}
              <span> v </span>
              {ContestData.match_data.away}
            </div>
            <div className="prediction-quiz">
              {fixtureResult.bonus_race && (
                <div className="section-txt">
                  {fixtureResult.bonus_race.message}
                </div>
              )}
              <div>
                {DisplayFixtureQueResult.length > 0 &&
                  DisplayFixtureQueResult.map((item, idx) => {
                    return (
                      <FixtureResultList
                        key={"fixtureQueResult" + idx}
                        idx={idx}
                        fixtureQueResult={item}
                        myContext={this}
                        ContestData={ContestData}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </MyContext.Consumer>
    );
  }
}
